export * from "./date";

export const fileIconsByType: Record<string, string> = {
  pdf: "/icons-v1_1/file-pdf.svg",
  xlsx: "/icons-v1_1/file-xls.svg",
  xls: "/icons-v1_1/file-xls.svg",
  default: "/icons-v1_1/file.svg",
} as const;
